import Colcade from 'colcade';

export const otTabsVertical = {
    init() {
        const instances = document.querySelectorAll('[data-ot-colcade]');
        instances?.forEach(instance => {
            const colcade = new Colcade(instance, {
                // These only accept classes
                columns: '.js-colcade-col',
                items: '.js-colcade-item'
            });
        })
    }
}